import React, { useEffect, useState } from 'react'
import {
  Container,
  Stack,
  Typography,
  Button,
  Grid,
  Pagination,
  Box,
  CircularProgress
} from '@mui/material'
import ProjectCard from './ProjectCard'
import AdminProjectFilter from './ProjectFilter'
import { fetchProjects, fetchUserProjects, filterProjects, filterUserProjects } from '../../services/Project'

const Project = ({ userTabsValue, userId }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  console.log("Projects:", projects);
  console.log("test", page, lastPage);
  console.log("userid", userId);


  // ---- Fetch projects -------

  const AllProjects = async () => {
    try {
      setLoading(true);
      let response;
      if (userId) {
        response = await fetchUserProjects(userId, page);
      } else {
        response = await fetchProjects(page);
      }
      console.log("response", response);
      setPage(response.current_page);
      setLastPage(response.last_page);
      setProjects(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching projects:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    AllProjects();
  }, [page, userId]);

  const handleFilterApply = async (filters) => {


    // Handle the filter application logic here
    console.log("Filters applied:", filters, userId);
    try {
      // setLoading(true);

      //const response = await filterProjects(filters);
      let response;
      if (userId) {
        console.log("userId for project and also filter s:", userId, filters);

        response = await filterUserProjects(userId, filters);
      } else {
        response = await filterProjects(filters);
      }

      console.log("Filtered response:", response);
      setProjects(response.data);
      setPage(response.current_page);
      setLastPage(response.last_page);
      setLoading(false);
    }
    catch (error) {
      console.error("Error applying filters:", error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Stack alignItems="center" sx={{ mb: 2 }}>
        <CircularProgress size={24} />
        <Typography variant="h6" color="text.secondary">
          Loading ...
        </Typography>
      </Stack>
    );
  }

  return (
    <React.Fragment>
      <Container maxWidth="lg" sx={{ mb: 0, padding: '0px' }} disableGutters>

        {projects.length === 0 ? (
          <Stack alignItems="center" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h6" color="text.secondary" align="center">
              No Projects
            </Typography>
          </Stack>
        ) : (
          <>
            {/* "poroject" and "filterIconbutton"  */}
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 2 }}
            >
              <Typography variant="h5" component="h1"
                sx={{ color: 'text.primary' }}>
                Projects
              </Typography>
              <AdminProjectFilter onFilterApply={handleFilterApply} />
            </Stack>

            {/* Project cards Grid or List */}


            <Grid container spacing={2}>
              {projects.map((project) => (
                <Grid
                  size={userTabsValue ? { xs: 12, sm: 6, md: 4 } : { xs: 12, sm: 6, md: 4 }}
                  key={project.project_id}>
                  <ProjectCard projectContent={project} />
                </Grid>
              ))}


            </Grid>

            {/* Pagination */}
            {lastPage > 1 && (
              <Stack spacing={2} sx={{ mt: 2, mb: 2, alignItems: 'center' }}>
                <Pagination
                  count={lastPage}
                  page={page}
                  onChange={(event, value) => {
                    setPage(value);
                    //AllProjects(value);
                  }}
                  color="primary"
                />
              </Stack>
            )}
          </>
        )}
      </Container>
    </React.Fragment>
  )
}

export default Project